module.exports = __webpack_public_path__ + "files/59790616430f3cf73c149a2ba0885bb9.png";